<script>
import axios from 'axios';

import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';
import Multiselect from 'vue-multiselect';

import las from '../assets/Local_Authority_Districts_2018_12.json';

// import { validationMixin } from 'vuelidate'
// import { required, requiredIf, alpha, alphaNum, numeric, integer, minValue, minLength, helpers } from 'vuelidate/lib/validators';
// Vue.use(Vuelidate);

export default {
    name: 'CostCalculatorComponent',
    components: {
        axios,
        Multiselect,
        VueSlider,
    },
    // mixins: [validationMixin],
    props: {},
    data: function() {
        return {
            autonome: {
                hours: 2,
                rate: 13,
                cost: 26,
            },
            rate: {
                // marks: ['13.00',14,15,16,17,18,19,20,21,22,23,24,25],
                // marks: this.rateMarks,
                min: 13,
                max: 25,
                interval: 0.01,
                slider: 16.77,
                value: 16.77,
            },
            hours: {
                min: 1,
                max: 3,
                interval: 1,
                slider: 2,
                value: 2,
            },
            la_select: {
            },
            la_options: [],
            savings: {
                year1: {
                    gross: 0,
                    net: 0,
                },
                year3: {
                    gross: 0,
                    net: 0,
                },
                year10: {
                    gross: 0,
                    net: 0,
                },
            },
            showSavings: false,
            users: {
                min: 0,
                max: 500,
                interval: 1,
                // data: [1, 2, 5, 10, 50, 100, 250, 500, 1000, 2000],
                // marks: [1, 2, 5, 10, 50, 100, 250, 500, 1000, 2000],
                marks: function(value) {
                    return value % 50 === 0;
                },
                slider: 100,
                value: 100,
            }
        }
    },
    computed: {
        rate2dp: {
            get: function() {
                return this.rate.value;
            },
            set: function(newValue) {
                this.rate.value = parseFloat(parseFloat(newValue).toFixed(2));
            }
        },
        rateMarks: function() {
            let marks = [];
            for (var i = this.autonome.rate; i <= 25; i++) {
                // console.log(i);
                // marks.push(parseFloat(i).toFixed(2));
                marks.push(parseFloat(i));
            }
            return marks;
        },
        showCalculateButton: function() {
            if ( this.la_select.FID > 0
                && typeof this.la_select.LAD18NM === 'string' ) {
                return true;
            } else {
                return false;
            }
        },
    },
    methods: {
        calculate: function() {
            this.savings.year1.gross = this.rate.value * this.hours.value * this.users.value * 52;
            this.savings.year3.gross = this.savings.year1.gross * 2;
            this.savings.year10.gross = this.savings.year1.gross * 9;

            this.savings.year1.net = this.savings.year1.gross - (this.autonome.cost * 52 * this.users.value * 1);
            this.savings.year3.net = this.savings.year3.gross - (this.autonome.cost * 52 * this.users.value * 3);
            this.savings.year10.net = this.savings.year10.gross - (this.autonome.cost * 52 * this.users.value * 10);

            this.savings.year1.v1 = Math.round((this.rate.slider - this.autonome.rate) * this.hours.slider * this.users.slider * 52);
            this.savings.year3.v1 = this.savings.year1.v1 * 3 + this.rate.slider * this.hours.slider * this.users.slider * 52;
            this.savings.year10.v1 = this.savings.year1.v1 * 10 + this.rate.slider * this.hours.slider * this.users.slider * 52;

            this.showSavings = true;

            // axios.post('http://api-laravel.test/staging/costcalculator', {
            axios.post('https://admin.autono.me.uk/staging/costcalculator', {
                LAD18NM: this.la_select.LAD18NM,
                FID: this.la_select.FID,
                hours: this.hours.value,
                rate: this.rate.value,
                users: this.users.value,
            })
            .then(function (response) {
                // console.log('response', response);
                // currentObj.output = response.data;
            })
            .catch(function (error) {
                // console.log('error', error);
                // currentObj.output = error;
            });
        },
        displaySaving: function(value) {
            return value.toLocaleString();
        },
        sliderRate: function(value) {
            this.rate.value = value;
        },
        sliderHours: function(value) {
            this.hours.value = value;
        },
        sliderUsers: function(value) {
            this.users.value = value;
        },
        validateRate: function() {
            if (this.rate.value > this.rate.max) {
                this.rate.value = this.rate.max;
            } else if (this.rate.value < this.rate.min) {
                this.rate.value = this.rate.min;
            }
            this.rate.slider = this.rate.value;
        },
        validateHours: function() {
            if (this.hours.value > this.hours.max) {
              this.hours.value = this.hours.max;
            } else if (this.hours.value < this.hours.min) {
                this.hours.value = this.hours.min;
            }
            this.hours.slider = this.hours.value;
        },
        validateUsers: function() {
            if (this.users.value > this.users.max) {
              this.users.value = this.users.max;
            } else if (this.users.value < this.users.min) {
                this.users.value = this.users.min;
            }
            this.users.slider = this.users.value;
        },
        getLasOptions: function() {

            // JSON to array
            las.features.forEach(feature => {
                this.la_options.push({
                    FID: feature.properties.FID,
                    LAD18NM: feature.properties.LAD18NM,
                })
            });

            // Sort alphabetically
            this.la_options.sort(function(a, b) {
               return a.LAD18NM.localeCompare(b.LAD18NM);
            });
        }
    },
    mounted: function() {
        this.getLasOptions();
    },
    watch: {
        'hours.value': function() {
            this.showSavings = false;
        },
        'rate.value': function() {
            this.showSavings = false;
        },
        'users.value': function() {
            this.showSavings = false;
        }
    },
}
</script>

<template>
<div>
    <div class="row justify-content-md-center">
        <div class="col-12 col-md-12 col-lg-9 col-xl-8">
            <div class="card">
                <div class="card-header">
                    <h4><strong>AutonoMe Savings Calculator</strong></h4>
                </div>
                <div class="card-body">
                    <p>This tool helps Local Authorities understand and predict the cost savings of your Learning Disability service users with AutonoMe</p>
                    <!-- <p>AutonoMe costs £26 per week to support a service user</p> -->
                    <p>1 hour of AutonoMe support is £13.</p>
                    <p>On average AutonoMe support most service users for 2 hours per week.</p>
                    <div class="form">
                        <div class="form-group row">
                            <label class="col-12 col-form-label" for="las">
                                <strong>Please select your Local Authority District</strong>
                            </label>
                        </div>
                        <div class="form-group row">
                            <div class="col-12">
                                <!-- <input type="hidden" id="carer_id" name="carer_id"
                                 :value="carer.id" required> -->

                                <multiselect id="select-la" name="" v-model="la_select"
                                 class="" :options="la_options"
                                 track-by="FID" label="LAD18NM" :searchable="true" :show-labels="false">
                                </multiselect>
                            </div>
                        </div>
                        <div v-if="showCalculateButton">
                            <div class="form-group row">
                                <label class="col-9 col-xl-7 col-form-label" for="rate">
                                    <strong>Please enter your average hourly cost of supporting a service user (&pound;): </strong>
                                </label>
                                <div class="col-3 d-flex">
                                    <input id="rate" class="form-control-sm align-self-center no-validation" v-model="rate2dp" type="number"
                                      :min="rate.min" :max="rate.max" :step="rate.interval" @blur="validateRate">
                                </div>
                            </div>

                            <div class="row justify-content-center mb-5">
                                <div class="col-12 col-sm-11">
                                    <vue-slider v-model="rate.slider" :min="rate.min" :max="rate.max" :interval="rate.interval"
                                     :marks="rateMarks" :tooltip="'none'" @change="sliderRate"></vue-slider>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-9 col-xl-7 col-form-label" for="users">
                                    <strong>Please select the number of service users who could benefit from AutonoMe support: </strong>
                                </label>
                                <div class="col-3 d-flex">
                                    <input id="users" class="form-control-sm align-self-center no-validation" v-model="users.value"
                                     type="number" :min="users.min" :max="users.max" @blur="validateUsers">
                                </div>
                            </div>
                            <div class="row justify-content-center mb-5">
                                <div class="col-12 col-sm-11">
                                    <vue-slider v-model="users.slider" :min="users.min" :max="users.max" :interval="users.interval"
                                     :marks="users.marks" :tooltip="'none'" @change="sliderUsers"></vue-slider>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-9 col-xl-7 col-form-label" for="hours">
                                    <!-- <strong>How many support hours do you want to save per service user? </strong> -->
                                    <strong>Please select the number of weekly support hours for each service user: </strong>
                                </label>
                                <div class="col-3 d-flex">
                                    <input id="hours" class="form-control-sm align-self-center no-validation" v-model="hours.value"
                                     type="number" :min="hours.min" :max="hours.max" @blur="validateHours">
                                </div>
                            </div>
                            <div class="row justify-content-center mb-5">
                                <div class="col-12 col-sm-11">
                                    <vue-slider v-model="hours.slider" :min="hours.min" :max="hours.max" :interval="hours.interval"
                                     :marks="true" :tooltip="'none'" @change="sliderHours"></vue-slider>
                                </div>
                            </div>
                            <!-- <div class="row">
                                <p class="col-12 text-center">Evidence shows within 12 months of support, AutonoMe service users require on average 2 fewer hours of 1:1 care</p>
                            </div> -->
                        </div>
                    </div>
                    <div class="row justify-content-center mb-4" v-if="showCalculateButton">
                        <div class="col-12 text-center">
                            <button type="button" class="btn btn-primary" @click="calculate">
                                <h5 class="mb-0 d-none d-block p-1"><strong>Calculate</strong></h5>
                            </button>
                        </div>
                    </div>
                    <transition name="fade">
                        <div class="row mb-4 pt-3" v-if="showSavings">
                            <div class="col-4">
                                <div class="row justify-content-center">
                                    <div class="card">
                                        <div class="card-header px-3 px-md-4">
                                            <h5 class="mb-0 d-none d-md-block"><strong>Year 1 savings</strong></h5>
                                            <h6 class="mb-0 d-block d-md-none"><strong>Year 1 savings</strong></h6>
                                        </div>
                                        <div class="card-body text-center px-1">
                                            <h5 class="text-primary"><strong>&pound;{{ displaySaving(this.savings.year1.v1) }}</strong></h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="row justify-content-center">
                                    <div class="card">
                                        <div class="card-header px-3 px-md-4">
                                            <h5 class="mb-0 d-none d-md-block text-center"><strong>Year 3 savings</strong></h5>
                                            <h6 class="mb-0 d-block d-md-none text-center"><strong>Year 3 savings</strong></h6>
                                        </div>
                                        <div class="card-body text-center px-1">
                                            <!-- <span>Gross </span><h5><strong><span class="text-primary">&pound;{{ displaySaving(savings.year3.gross) }}</span></strong></h5>
                                            <span>Net </span><h5><strong><span class="text-primary">&pound;{{ displaySaving(savings.year3.net) }}</span></strong></h5> -->
                                            <h5 class="text-primary"><strong>&pound;{{ displaySaving(this.savings.year3.v1) }}</strong></h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="row justify-content-center">
                                    <div class="card">
                                        <div class="card-header px-3 px-md-4">
                                            <h5 class="mb-0 d-none d-md-block text-center"><strong>Year 10 savings</strong></h5>
                                            <h6 class="mb-0 d-block d-md-none text-center"><strong>Year 10 savings</strong></h6>
                                        </div>
                                        <div class="card-body text-center px-1">
                                            <!-- <span>Gross </span><h5><strong><span class="text-primary">&pound;{{ displaySaving(savings.year10.gross) }}</span></strong></h5>
                                            <span>Net </span><h5><strong><span class="text-primary">&pound;{{ displaySaving(savings.year10.net) }}</span></strong></h5> -->
                                            <h5 class="text-primary"><strong>&pound;{{ displaySaving(this.savings.year10.v1) }}</strong></h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>


                </div>
            </div>
            <!-- <div class="card-footer">
            </div> -->
        </div>
    </div>
</div>
</template>
